// テキストの行分割 (純ロジック)。measure は Canvas の measureText を注入する。
// - 明示的な改行は常に分ける
// - boxWidth があれば折り返す: CJK は 1 文字ずつ、ラテンは単語単位。行頭禁則 (、。」)
// - 縦書きは行 = 列として同じ関数を使う (measure に高さ相当を渡す)

export interface LayoutLine {
  text: string
  /** 行の描画幅 (字間込み) */
  width: number
}

const KINSOKU_HEAD = new Set('、。，．・：；？！ゝゞヽヾ々ー）］｝〕〉》」』】〙〗〟’”｠»ぁぃぅぇぉっゃゅょゎゕゖァィゥェォッャュョヮヵヶ'.split(''))
const isCjk = (ch: string) => /[　-ヿ㐀-鿿豈-﫿＀-￯]/.test(ch)

export function layoutText(text: string, measure: (s: string) => number, letterSpacing: number, boxWidth?: number): LayoutLine[] {
  const paragraphs = text.replace(/\r\n?/g, '\n').split('\n')
  const out: LayoutLine[] = []
  const widthOf = (s: string) => (s.length === 0 ? 0 : measure(s) + letterSpacing * s.length)
  for (const para of paragraphs) {
    if (!boxWidth || para.length === 0) {
      out.push({ text: para, width: widthOf(para) })
      continue
    }
    // トークン: CJK は 1 文字、それ以外は単語 (空白を含む)
    const tokens: string[] = []
    let cur = ''
    for (const ch of para) {
      if (isCjk(ch)) {
        if (cur) tokens.push(cur)
        cur = ''
        tokens.push(ch)
      } else if (ch === ' ') {
        cur += ch
        tokens.push(cur)
        cur = ''
      } else {
        cur += ch
      }
    }
    if (cur) tokens.push(cur)
    let line = ''
    for (const tk of tokens) {
      const candidate = line + tk
      const kinsoku = KINSOKU_HEAD.has(tk)
      if (line && widthOf(candidate.trimEnd()) > boxWidth && !kinsoku) {
        out.push({ text: line.trimEnd(), width: widthOf(line.trimEnd()) })
        line = tk.trimStart()
      } else {
        line = candidate
      }
      // 単語自体が幅を超えるときは文字単位で割る (禁則でぶら下げた分は割らない)
      while (!kinsoku && widthOf(line.trimEnd()) > boxWidth && line.trimEnd().length > 1) {
        let cut = line.length - 1
        while (cut > 1 && widthOf(line.slice(0, cut)) > boxWidth) cut--
        out.push({ text: line.slice(0, cut), width: widthOf(line.slice(0, cut)) })
        line = line.slice(cut)
      }
    }
    out.push({ text: line.trimEnd(), width: widthOf(line.trimEnd()) })
  }
  return out
}
